import client from './client'

// Reshape設定のトグル
export interface ReshapeToggleRequest {
  reshape_type_label: string
  active: boolean
}

export interface ReshapeToggleResponse {
  message: string
  reshape_type_label: string
  active: boolean
}

// Alert設定のトグル
export interface AlertToggleRequest {
  alert_type_label: string
  active: boolean
}

export interface AlertToggleResponse {
  message: string
  alert_type_label: string
  active: boolean
}

// Reshape設定の取得
export interface ReshapeType {
  label: string
  class_name: string
  description: string
  exists_in_db: boolean
  user_setting: boolean | null
}

export interface ReshapeTypesResponse {
  reshape_types: ReshapeType[]
  total: number
}

// Alert設定の取得
export interface AlertType {
  label: string
  class_name: string
  description: string
  exists_in_db: boolean
  user_setting: boolean | null
}

export interface AlertTypesResponse {
  alert_types: AlertType[]
  total: number
}

// Reshape設定をトグルする
export const toggleReshapeSetting = async (
  request: ReshapeToggleRequest
): Promise<ReshapeToggleResponse> => {
  const response = await client.post(
    '/api/user-reshape-settings/toggle/',
    request
  )
  return response.data
}

// Alert設定をトグルする
export const toggleAlertSetting = async (
  request: AlertToggleRequest
): Promise<AlertToggleResponse> => {
  const response = await client.post(
    '/api/user-gigi-alert-settings/toggle/',
    request
  )
  return response.data
}

// Reshape設定を取得する
export const getUserReshapeSettings =
  async (): Promise<ReshapeTypesResponse> => {
    const response = await client.get('/api/user-reshape-settings/types/')
    return response.data
  }

// Alert設定を取得する
export const getUserAlertSettings = async (): Promise<AlertTypesResponse> => {
  const response = await client.get('/api/user-gigi-alert-settings/types/')
  return response.data
}
